import { useEffect, useState } from 'react'
import { RowSelectionState } from '@tanstack/react-table'

import { useTable } from '@/ui/Table'
import { useAreaStore, useGetAreasRoutes } from '@/modules/Areas'
import { useManageDisruptionsColumns } from '@/pages/Disruptions/hooks/useManageDisruptionsColumns'
import { useDisruptionsTableFormStateStore } from '@/pages/Disruptions/store'
import { useDisruptionsColumns } from '@/pages/Disruptions/hooks/useDisruptionsColumns'
import { filterDisruptionsByArea } from '@/pages/Disruptions/helpers/filterDisruptionsByArea'
import { useGetSharedDisruptions } from '../api/useGetSharedDisruptions'
import { DISRUPTIONS_COLUMNS } from '@/pages/Disruptions/constant'

export const useSharedDisruptionsTable = () => {
    const { data: disruptions = [], isLoading } = useGetSharedDisruptions()
    const columnVisibility = useManageDisruptionsColumns()
    const [rowSelection, setRowSelection] = useState<RowSelectionState>({})
    const { setSelectedRowId } = useDisruptionsTableFormStateStore()
    const { selectedAreaCode: globalFilter } = useAreaStore()
    const columns = useDisruptionsColumns()
    const { areaRoutes } = useGetAreasRoutes()

    const table = useTable({
        data: disruptions,
        columns,
        enableGlobalFilter: true,
        getRowId: (row) => row.id.toString(),
        onRowSelectionChange: setRowSelection,
        enableMultiRowSelection: false,
        globalFilterFn: filterDisruptionsByArea(
            globalFilter,
            areaRoutes.map((route) => route.route)
        ),
        state: {
            globalFilter,
            columnVisibility,
            rowSelection,
        },
    })

    useEffect(() => {
        // populate id of selected row to store
        if (Object.keys(rowSelection).length !== 0) {
            setSelectedRowId(Object.keys(rowSelection)[0])
        }
    }, [rowSelection])

    useEffect(() => {
        if (!isLoading && disruptions) {
            // Set initial sorting
            table.setSorting([
                {
                    id: DISRUPTIONS_COLUMNS.Status,
                    desc: false,
                },
            ])
        }
    }, [isLoading])

    return { table, setRowSelection }
}
